import Vue from 'vue';
import VueI18n from 'vue-i18n';
import LocalStorage from '@/services/localstorage';

Vue.use(VueI18n);

const messages = {
  id: {
    our_services: 'Layanan Kami',
    news_and_promos: 'Berita & Promo',
    partnership: 'Kemitraan',
    partnership_about: 'Tentang Kemitraan',
    about_paxel: 'Tentang Paxel',
    support: 'Bantuan',
    terms_and_conditions: 'Syarat & Ketentuan',
    privacy_policy: 'Kebijakan Privasi',
    follow: 'Ikuti Kami',
    download_our_app: 'Unduh Aplikasi Paxel',
    featured_features: 'Fitur Unggulan',
    content: 'Isi',
    featured_chose: 'Dipercaya oleh ratusan ribu UMKM hingga corporate, termasuk F&B. Memiliki stock point dengan fasilitas freezer dan chiller agar produk tetap segar.',
    featured_services: 'Melayani berbagai kategori produk, segar/beku atau barang berharga. Kerjasama marketplace/e-commerce, O2O, point-to-point delivery, dll',
    featured_workflow: 'API Integration dengan website/aplikasi, Corporate Dashboard untuk multiple shipment, dan Bulk Upload yang dapat di track melalui website.',
    testimonial_headline: 'test',
    banner_tagline: 'Berkembang Bersama Kami',
    banner_title: 'Mendukung bisnis Anda agar berkembang lebih cepat. Bergabung bersama kami untuk mencapai ROI bisnis Anda 4x lebih cepat.',
    partner_headline: 'Partner Kami',
    partner_tagline: 'Dipercaya oleh UKM dan Mitra Korporat, kami mengakselerasi perekonomian Indonesia.',
    viewMoreText: 'Lihat lebih banyak',
    viewLessText: 'Lihat lebih sedikit',
    getintouch_tagline: 'Kami sangat bersedia mendiskusikan kebutuhan bisnis kamu dan menjawab pertanyaan yang mungkin kamu miliki',
    getintouch: 'Hubungi Kami',
    track_your_shipment: 'Cek Resi',
    track_ongkir: 'Cek Ongkir',
    desc_footer: 'Seluruh Hak Cipta',
  },
  en: {
    our_services: 'Our Services',
    news_and_promos: 'News & Promo',
    partnership: 'Partnership',
    partnership_about: 'About Partnership',
    about_paxel: 'About Paxel',
    support: 'Support',
    terms_and_conditions: 'Terms & Conditions',
    privacy_policy: 'Privacy Policy',
    follow: 'Follow Us',
    download_our_app: 'Download Paxel App',
    featured_features: 'Featured Excellence',
    content: 'Content',
    featured_chose: 'Dipercaya oleh ratusan ribu UMKM hingga corporate, termasuk F&B. Memiliki stock point dengan fasilitas freezer dan chiller agar produk tetap segar.',
    featured_services: 'Dipercaya oleh ratusan ribu UMKM hingga corporate, termasuk F&B. Memiliki stock point dengan fasilitas freezer dan chiller agar produk tetap segar.',
    featured_workflow: 'API Integration dengan website/aplikasi, Corporate Dashboard untuk multiple shipment, dan Bulk Upload yang dapat di track melalui website.',
    testimonial_headline: 'test',
    banner_tagline: 'Grow With Us',
    banner_title: 'Support your business to grow faster than regular shipment. Join with us to earn 4x faster ROI of your business.',
    partner_headline: 'Our Partners',
    partner_tagline: 'Trusted by SMEs and our Corporate Partners, we are accelerating Indonesia\'s economy.',
    viewMoreText: 'View more',
    viewLessText: 'Show less',
    getintouch_tagline: 'We are eager to discuss your business needs and answer any question you may have',
    getintouch: 'Get in Touch',
    track_your_shipment: 'Track Shipment',
    track_ongkir: 'Check Rates',
    desc_footer: 'All Rights Reserved',
  },
};

const i18n = new VueI18n({
  locale: LocalStorage.getLanguage(), // set locale
  fallbackLocale: 'id', // set fallback locale
  messages, // set locale messages
});
export default i18n;
